// Search hub users to add as a thread viewer — GET /api/v1/sessions/users/search.
// Same shape as /admin/users (see entities/owner/model/toOwnerView.ts's
// toUserOptionList) but open to any authenticated user, not just agent
// owners/admins — sharing your own thread needs to find any hub user.

import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';
import { toUserOptionList } from '@/entities/owner';
import type { UserOptionView } from '@/entities/owner';

const MIN_SEARCH_LENGTH = 2;

function getClient() {
  return createApiClient({
    baseUrl: readEnv('VITE_API_BASE_URL') ?? '',
    auth: { getToken },
  });
}

export async function searchShareUsers(query: string, signal?: AbortSignal): Promise<UserOptionView[]> {
  const trimmed = query.trim();
  if (trimmed.length < MIN_SEARCH_LENGTH) {
    return [];
  }
  const raw = await getClient().request({
    path: '/api/v1/sessions/users/search',
    query: { q: trimmed },
    signal,
  });
  return toUserOptionList(raw);
}
